/** The compose layout breaks at Tailwind's `sm`, not the hook's 768px default. */
export const LAYOUT_BREAKPOINT = 640;
